import { Outlet, useLocation } from 'react-router';
import { Header } from '@/components/layout/header';
import { Footer } from '@/components/layout/footer';
import { MobileNav } from '@/components/layout/mobile-nav';
import { DashboardProvider } from '@/contexts/dashboard-context';
import { IntentActionsHandler } from '@/components/IntentActionsHandler';
import { useTabSwipe } from '@/hooks/use-tab-swipe';

export function AppLayout() {
  const location = useLocation();
  const isSignIn = location.pathname === '/signin';
  const { onTouchStart, onTouchMove, onTouchEnd, currentTabIndex } = useTabSwipe();

  return (
    <DashboardProvider>
      <IntentActionsHandler />
      <div className="flex min-h-screen flex-col">
        {!isSignIn && <Header />}
        <main
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          className={!isSignIn ? "flex-1 pt-[calc(env(safe-area-inset-top)+56px)]" : "flex-1"}
        >
          <Outlet />
        </main>
        {!isSignIn && <Footer />}
        {!isSignIn && (
          <MobileNav
            className="pb-[env(safe-area-inset-bottom)]"
            currentTabIndex={currentTabIndex}
          />
        )}
      </div>
    </DashboardProvider>
  );
}
